import React, { useContext, useState, useEffect } from "react";

import axios from "axios";
import { PropTypes } from "prop-types";

import { useAuth } from "./AuthContext";

const SessionContext = React.createContext();

export function useSession() {
	return useContext(SessionContext);
}

export function SessionProvider({ children }) {
	SessionProvider.propTypes = {
		children: PropTypes.object,
	};
	const [loading] = useState(false);
	const [sessionId, setSessionId] = useState("");
	const [previousSessionId, setPreviousSessionId] = useState("");
	const [nextSessionId, setNextSessionId] = useState("");
	const [nickname, setNickname] = useState("");
	const [matchedUser, setMatchedUser] = useState("");
	const { userId } = useAuth();

	function loadSessionState() {
		setSessionId(localStorage.getItem("sessionId"));
		setPreviousSessionId(localStorage.getItem("previousSessionId"));
		setNextSessionId(localStorage.getItem("nextSessionId"));
		setNickname(localStorage.getItem("nickname"));
	}

	useEffect(() => {
		loadSessionState();
	}, []);

	function updateSessionId(payload) {
		localStorage.setItem("sessionId", payload.id);
		setSessionId(payload.id);
	}

	function updatePreviousSessionId(payload) {
		if(payload.id) {
			localStorage.setItem("previousSessionId", payload.id);
		} else {
			localStorage.removeItem("previousSessionId");
		}
			setPreviousSessionId(payload.id);
	}

	function updateNextSessionId(payload) {
		if(payload.id) {
			localStorage.setItem("nextSessionId", payload.id);
		} else {
			localStorage.removeItem("nextSessionId");
		}
		setNextSessionId(payload.id);
	}

	function updateNickname(payload) {
		localStorage.setItem("nickname", payload.name);
		setNickname(payload.name);
	}

	function updateMatchedUserName(payload) {
		const { myName, partnerName } = payload.names;
		setNickname(myName);
		setMatchedUser(partnerName);
	}

	// async function getSessionIdFromAPI() {
	// 	var token = localStorage.getItem("access-token");
	// 	try {
	// 		const sessionData = await axios.get(
	// 			`${process.env.REACT_APP_BASE_SERVER_URL}/api/dashboard/checksession`,
	// 			{
	// 				headers: {
	// 					Authorization: token,
	// 				},
	// 			}
	// 		);

	// 		if (sessionData.data.data.results.length > 0) {
	// 			let newSessionId = sessionData.data.data.results[0].sessionId;
	// 			updateSessionId({ id: newSessionId });
	// 		} else {
	// 			alert("No Ongoing Sessions ");
	// 			updateSessionId({ id: null });
	// 		}
	// 	} catch (err) {
	// 		console.log(err);
	// 	}
	// }

	const value = {
		updateSessionId,
		sessionId,
		previousSessionId,
		nextSessionId,
		nickname,
		updatePreviousSessionId,
		updateNextSessionId,
		updateNickname,
		updateMatchedUserName,
		matchedUser,
		setSessionId,
	};

	return (
		<SessionContext.Provider value={value}>
			{loading === false && children}
		</SessionContext.Provider>
	);
}
